import React, { useMemo } from 'react';

const allowedTags = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'blockquote', 'a']);
const excludedTags = new Set(['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'template']);

// Render only supported formatting, without executing HTML or event attributes.
export default function RichContent({ value = '', className = '' }) {
  const content = useMemo(() => {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    const render = (node, key) => {
      if (node.nodeType === 3) return node.textContent;
      if (node.nodeType !== 1) return null;
      const tag = node.tagName.toLowerCase();
      if (excludedTags.has(tag)) return null;
      const children = Array.from(node.childNodes, (child, index) => render(child, index));
      if (!allowedTags.has(tag)) return <React.Fragment key={key}>{children}</React.Fragment>;
      const props = { key };
      if (tag === 'a') {
        const href = node.getAttribute('href') || '';
        if (/^(https?:\/\/|mailto:|\/(?!\/)|#)/i.test(href)) props.href = href;
      }
      return React.createElement(tag, props, ...(tag === 'br' ? [] : children));
    };
    return Array.from(doc.body.childNodes, (node, index) => render(node, index));
  }, [value]);
  return <div className={`whitespace-pre-line break-words leading-relaxed [&_h2]:text-xl [&_h3]:text-lg [&_h4]:text-base [&_h2]:font-bold [&_h3]:font-bold [&_h4]:font-bold [&_p]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_blockquote]:border-l-4 [&_blockquote]:pl-4 [&_a]:text-orange-700 [&_a]:underline ${className}`}>{content}</div>;
}
